import { isObject, isString } from '@pct-ts/typeguard';

export interface BackendErrorWithMessage {
  message: string;
  errors: {
    field: string;
    strId: string;
  }[];
}

export function isBackendErrorWithMessage(obj: unknown): obj is BackendErrorWithMessage {
  return (
    isObject(obj) &&
    obj !== null &&
    'message' in obj &&
    'errors' in obj &&
    isString(obj.message) &&
    Array.isArray(obj.errors) &&
    obj.errors.every(
      (error: unknown) =>
        isObject(error) &&
        error !== null &&
        'field' in error &&
        'strId' in error &&
        isString(error.field) &&
        isString(error.strId),
    )
  );
}
